import logger from "Libs/logger";
import { isJson } from "Libs/utils";
import { createAppAsyncThunk } from "Store/createAppAsyncThunk";

import type { AsyncThunkOptionType } from "Reducers/types";
import {
  updateMaintenanceWindowRequest,
  UpdateMaintenanceWindowResponse,
  MaintenanceWindowRecurrence
} from "Api/projectSettings/updateMaintenanceWindow.request";

export const updateMaintenanceWindow = createAppAsyncThunk<
  UpdateMaintenanceWindowResponse,
  {
    projectId: string;
    maintenanceWindow: { recurrence: MaintenanceWindowRecurrence };
  },
  AsyncThunkOptionType
>(
  "app/project/maintenance_window/update",
  async ({ projectId, maintenanceWindow }, { rejectWithValue }) => {
    try {
      const updatedMaintenanceWindow = await updateMaintenanceWindowRequest(
        projectId,
        maintenanceWindow
      );

      return updatedMaintenanceWindow;
    } catch (error) {
      logger(error, {
        action: "maintenance_window_update"
      });
      const isJsonError = isJson(error);
      const updatedError = isJsonError ? JSON.parse(error)?.message : error;
      return rejectWithValue(updatedError);
    }
  }
);
